import { initHeaderLinks } from './HeaderListModule.js';

// Run with default options (.header-list and h2)
initHeaderLinks();